import React from 'react';
import GamePanelContainer from 'containers/gamePanelContainer';
import StatPanelContainer from 'containers/statPanelContainer';

import History from '../containers/historyPanelContainer';
import styles from './style.module.scss';

export default class Game extends React.Component{
    
    render() {

        return (
        <div className={styles.container_main}>
            <div className="container_submain">
                <GamePanelContainer />
                <StatPanelContainer />
            </div>
            <History />
        </div>
        )
    }
}